import React from 'react'
import PropTypes from 'prop-types'

import SecondaryButton from '@components/inputs/button/secondaryButton'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Loading from '../../loading'

import {
  CloseIcon,
  Container,
  ButtonArea
} from './styles'
import { Title, Subtitle } from '../styles'

import 'material-icons/iconfont/outlined.css'

import ConfirmationModal from '@components/modal/confirmationModal'

const ContinueModal = ({
  title,
  subtitle,
  primaryButtonLabel,
  secondaryButtonLabel,
  onClickPrimary,
  onClickSecondary,
  loading,
  isOpen,
  setClose
}) => {
  return (
    <ConfirmationModal isOpen={isOpen}>
      <Container>
        <CloseIcon className="material-icons-outlined" onClick={setClose}>close</CloseIcon>
        <Title style={{ marginBottom: 0 }}>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <ButtonArea>
          <PrimaryButton onClick={onClickPrimary}>
            {loading ? <Loading /> : primaryButtonLabel}
          </PrimaryButton>
          <SecondaryButton onClick={onClickSecondary || setClose}>
            {secondaryButtonLabel}
          </SecondaryButton>
        </ButtonArea>
      </Container>
    </ConfirmationModal>
  )
}

ContinueModal.propTypes = {
  isOpen: PropTypes.bool,
  setClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  secondaryButtonLabel: PropTypes.string,
  onClickPrimary: PropTypes.func.isRequired,
  onClickSecondary: PropTypes.func,
  loading: PropTypes.bool,
}

ContinueModal.defaultProps = {
  isOpen: false,
  title: 'Continuar ?',
  subtitle: null,
  primaryButtonLabel: 'Sim',
  secondaryButtonLabel: 'Voltar',
  onClickSecondary: null,
  loading: false,
}

export default ContinueModal
